// Drop a resize that leaves a side of the box shorter than this fraction of
// the image's short side.
export const MIN_NORMALIZED_SIZE = 0.005;

export interface Geom {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

export const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

/** A box's bounding box. Moving and resizing live in `oriented-box`. */
export const pointsToGeom = (points: number[][]): Geom => {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const [x, y] of points) {
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  }
  return { minX, minY, maxX, maxY };
};
